import React from "react";
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  // Round Status styles
  debitCompleted: {
    backgroundColor: "#4caf50 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  creditStarted: {
    backgroundColor: "#2196f3 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  creditCompleted: {
    backgroundColor: "#4caf50 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  refundCompleted: {
    backgroundColor: "#ff9800 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  debitFailed: {
    backgroundColor: "#f44336 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  creditFailed: {
    backgroundColor: "#f44336 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  refundFailed: {
    backgroundColor: "#f44336 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  // Bet Status styles
  won: {
    backgroundColor: "#4caf50 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  loss: {
    backgroundColor: "#f44336 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  void: {
    backgroundColor: "#9e9e9e !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  // Transaction Type styles
  coinPurchased: {
    backgroundColor: "#9c27b0 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  betPlaced: {
    backgroundColor: "#ff5722 !important",
    color: "#fff !important",
    fontWeight: "600 !important",
  },
  // Default style
  default: {
    backgroundColor: "#e0e0e0 !important",
    color: "#000 !important",
    fontWeight: "500 !important",
  },
}));

interface StatusBadgeProps {
  value: string;
  type: "roundStatus" | "resolved" | "transactionType" | "market";
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ value, type }) => {
  const classes = useStyles();

  if (!value) return <span>-</span>;

  const getStatusClass = () => {
    const val = value.toLowerCase().replace(/_/g, "");

    if (type === "roundStatus") {
      switch (val) {
        case "debitcompleted":
          return classes.debitCompleted;
        case "creditstarted":
          return classes.creditStarted;
        case "creditcompleted":
          return classes.creditCompleted;
        case "refundcompleted":
          return classes.refundCompleted;
        case "debitfailed":
          return classes.debitFailed;
        case "creditfailed":
          return classes.creditFailed;
        case "refundfailed":
          return classes.refundFailed;
        default:
          return classes.default;
      }
    }

    if (type === "resolved") {
      switch (val) {
        case "won":
          return classes.won;
        case "lost":
          return classes.loss;
        case "void":
          return classes.void;
        default:
          return classes.default;
      }
    }

    if (type === "transactionType") {
      switch (val) {
        case "coinpurchased":
          return classes.coinPurchased;
        case "betplaced":
          return classes.betPlaced;
        default:
          return classes.default;
      }
    }

    return classes.default;
  };

  const getDisplayLabel = () => {
    // Convert snake_case to Title Case
    return value
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <Chip
      label={getDisplayLabel()}
      className={getStatusClass()}
      size="small"
      sx={{
        fontSize: "11px",
        height: "22px",
        minWidth: "80px",
      }}
    />
  );
};

export default StatusBadge;
